export default {
        "logout-success": "Déconnexion réussie",
        "logout-error": "Échec de la déconnexion",
        "confirm": "Confirmer",
        "copySuccess": "Copié",
        "server": {
            "selectServer": "Sélectionner le serveur",
            "serverAmerica": "Amérique",
            "serverEurope": "Europe",
            "serverAsia": "Asia",
            "serverHMT": "HMT",
            "serverSEA": "SEA",
            "noRole": "Aucune donnée de personnage.\n Veuillez d'abord démarrer le jeu.",
            "noRole2": "Aucune donnée de personnage.",
            "noOtherRole": "Aucun personnage détecté,\n impossible de changer de serveur."
        },
        "uidlogin": { 
            "enterCode": "Veuillez entrer le code",
            "enterCode2": "Veuillez entrer le code correct",
            "sendCode": "Envoyer le code",
            "agree": "Veuillez lire et accepter les Termes d'Utilisation et la Politique de Confidentialité",
            "sended": "Envoyé",
            "tipUid": "Veuillez entrer l'UID",
            "tipUid2": "Veuillez entrer l'UID correct",
            "login": "Se connecter",
            "loginFail": "Connexion échouée, veuillez vérifier l'UID et le code",
            "loginSuccess": "Connexion réussie",
            "sendFail": "Aucun rôle trouvé",
            "sendFail2": "Envoi échoué",
            "sendFast": "Envoi trop rapide",
            "sendFast2": "Envoi trop rapide, veuillez réessayer dans {time}",
            "codeInvaild": "Code expiré"
        },
        "share-tips": "Clic droit ou capture pour enregistrer et partager"
};